import { SectorSelector } from './header/SectorSelector'
import { NotificationsMenu } from './header/NotificationsMenu'
import { UserMenu } from './header/UserMenu'
// import { Link } from 'react-router-dom'
// import { Plus } from 'lucide-react'

export const Header = () => {
  return (
    <header className="px-2 sm:px-4 md:px-6 h-14 md:h-16 relative z-[200]">
      <div className="flex items-center justify-between h-full">
        {/* Left side - Breadcrumbs space (handled by layout) */}
        <div className="flex items-center space-x-4">
          {/* Space for breadcrumbs */}
        </div>

        {/* Right side - User context and controls */}
        <div className="flex items-center gap-0.5 sm:gap-1">
          {/* Separator - hidden on mobile */}
          <div className="hidden sm:block h-6 w-px bg-gray-300 dark:bg-neutral-600 mx-1 md:mx-2" />
          
          {/* Sector Selector */}
          <SectorSelector />
          
          {/* Separator - hidden on mobile */}
          <div className="hidden sm:block h-6 w-px bg-gray-300 dark:bg-neutral-600 mx-1 md:mx-2" />
          
          {/* User Menu */}
          <UserMenu />
          
          {/* Separator - hidden on mobile */}
          <div className="hidden sm:block h-6 w-px bg-gray-300 dark:bg-neutral-600 mx-1 md:mx-2" />
          
          {/* Notifications - Now at the rightmost position */}
          <NotificationsMenu />
        </div>
      </div>
    </header>
  )
}
